module.exports = __webpack_public_path__ + "static/media/mail.836e132d.svg";